import { createFragmentRegistry } from '@apollo/client/cache';

export const fragmentRegistry = createFragmentRegistry();
